// extracted by mini-css-extract-plugin
module.exports = {"coming_soon":"style_coming_soon__1NBcO","section_title":"style_section_title__3z0_N"};